'use client';
import Shield from '@/app/_components/ui/icons/Shield.svg';
import SmallArrowLeft from '@/app/_components/ui/icons/SmallArrowLeft.svg';
import Close from '@/app/_components/ui/icons/Close.svg';
import BoxTick from '@/app/_components/ui/icons/BoxTick.svg';
import FreeDelivery from '@/app/_components/ui/icons/FreeDelivery.svg';
import Shipping from '@/app/_components/ui/icons/Shipping.svg';
import Clock from '@/app/_components/ui/icons/Clock.svg';
import React, { useState } from 'react';
import Modal from 'react-modal';

import Image from 'next/image';
import { useProductContext } from '@/app/_providers/ProductContext';

export default function SpShipping({ delivery, offline, shipType, status }) {
  const [openModal, setOpenModal] = useState(false);
  const [openGuaranteeModal, setOpenGuaranteeModal] = useState(false);
  const { currentVariation } = useProductContext();
  const stock = currentVariation?.stock;

  const onClose = () => {
    setOpenModal(false);
  };
  return (
    <>
      <div className="prosuctGuarantee items-center flex pb-4 ">
        <Shield />
        <div className="text-xs md:text-sm text-drak-gray w-full pr-2 flex">
          گارانتی اصالت و سلامت فیزیکی کالا
          <div
            onClick={() => setOpenGuaranteeModal(true)}
            className="text-gray-200  text-color-primary cursor-pointer pr-2 inline-flex items-center"
          >
            <span className="pl-2 text-color-primary font-bold">مشاهده</span>
            <SmallArrowLeft fill="#2A75BB" />
          </div>
          <Modal
            isOpen={openGuaranteeModal}
            onRequestClose={() => setOpenGuaranteeModal(false)}
            ariaHideApp={false}
            portalClassName="guaranteeModal"
            className="guaranteeModal"
            overlayClassName="modalOverlay"
          >
            <div className="guaranteeModal bg-white border border-gray-300  rounded-sm xs:m-4 md:m-0">
              <div className="">
                <div className="flex justify-between items-center md:p-5 xs:p-2 border-b border-light-gray-200">
                  <h2 className="xs:text-sm md:text-base font-semibold">
                    گارانتی اصالت و سلامت فیزیکی کالا
                  </h2>
                  <button onClick={() => setOpenGuaranteeModal(false)}>
                    <Close />
                  </button>
                </div>

                <div className="md:p-5 xs:p-2 xs:text-sm md:text-base">
                  <p>
                    درخواست مرجوع کردن کالا تنها در صورتی قابل تایید است که کالا
                    در شرایط اولیه باشد (در صورت پلمپ بودن، کالا نباید باز شده
                    باشد)، جعبه و کارتن نباید آسیب دیده باشد.
                  </p>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
      <div className="productShipping text-xs md:text-sm relative py-5 border-t border-light-gray-150">
        <div className="toc-border"></div>
        <div className="flex">
          <div>
            <BoxTick />
          </div>
          <div className="pr-2">
            <div>
              <span className="text-gray-600 pl-2">وضعیت محصول:</span>
              <span
                className={`${
                  status == 2 ? 'text-red-main' : 'text-black'
                } font-bold`}
              >
                {status == 2
                  ? 'توقف تولید'
                  : stock > 0
                  ? !offline
                    ? 'موجود در انبار'
                    : 'استعلام از کارشناس فروش'
                  : 'ناموجود'}
              </span>
            </div>
            <div className="mt-3">
              <span className="text-gray-600 pl-2">زمان و هزینه ارسال:</span>
              <span
                className=" text-gray-200 text-color-primary cursor-pointer inline-flex items-center"
                onClick={() => setOpenModal(true)}
              >
                <span className="pl-2 text-color-primary font-bold">
                  مشاهده
                </span>
                <SmallArrowLeft fill="#2A75BB" />
              </span>
            </div>
            <div className="mt-3">
              {shipType && shipType == 'free' ? (
                <div className="inline-flex items-center bg-light-green-100 rounded-full px-2 py-1">
                  <FreeDelivery />
                  <span
                    className="pr-2 text-green-heavy text-sm
                  "
                  >
                    ارسال رایگان
                  </span>
                </div>
              ) : (
                <>
                  <span className="text-gray-600 pl-2">سریع‌ترین ارسال:</span>
                  {stock > 0 && !offline ? (
                    delivery === 1 ? (
                      <span className="text-black">امروز</span>
                    ) : (
                      <span className="text-black">
                        ارسال از {delivery} روز کاری دیگر
                      </span>
                    )
                  ) : (
                    <span>-</span>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <Modal
          isOpen={openModal}
          onRequestClose={onClose}
          ariaHideApp={false}
          portalClassName="modalShipping"
          className="modalShipping"
          overlayClassName="modalOverlay"
        >
          <div className="modalShipping bg-white grid grid-cols-12 border border-gray-300  rounded-sm xs:m-4 md:m-0">
            <div className="shippingImg relative xs:hidden md:col-span-4  md:block">
              <Image
                src="/images/shipping.png "
                layout="fill"
                objectFit="fill"
                className="absolute"
              />
            </div>
            <div className="xs:col-span-12  md:col-span-8">
              <div className="flex justify-between items-center md:p-5 xs:p-2 md:pb-1">
                <h2 className="xs:text-sm md:text-base">زمان و هزینه ارسال</h2>
                <button onClick={onClose}>
                  <Close />
                </button>
              </div>
              <div className="md:pt-2 md:pb-4">
                <div className="w-full border-t border-light-gray-200"></div>
              </div>
              <div className="xs:p-4 md:p-6 text-xs">
                <div className="flex ">
                  <div className="pl-2">
                    <Shipping />
                  </div>
                  <div>
                    <p>ارسال از طریق الوپیک و اسنپ باکس برای شهر تهران</p>
                  </div>
                </div>
                <div className="flex xs:mt-4 md:mt-8">
                  <div className="pl-2">
                    <Clock />
                  </div>
                  <div className="flex flex-1 flex-wrap flex-col">
                    <div className="flex pb-4">
                      <div className="pl-2 min-w-[100px]">شنبه تا چهارشنبه</div>
                      <div className="border-r border-light-gray-300 pr-3">
                        <div className="pb-2">
                          <span>ثبت سفارش قبل از ساعت ۱۵</span>
                          <span className="pr-6">
                            زمان ارسال بین ساعت ۱۶ تا ۱۹
                          </span>
                        </div>
                        <div>
                          <span>ثبت سفارش بعد از ساعت ۱۵</span>
                          <span className="pr-6">زمان ارسال روز بعد</span>
                        </div>
                      </div>
                    </div>
                    <div className="flex pb-4">
                      <div className="pl-2 min-w-[100px]">پنج شنبه </div>
                      <div className="border-r border-light-gray-300 pr-3">
                        <div className="pb-2">
                          <span>ثبت سفارش قبل از ساعت ۱۲</span>
                          <span className="pr-6">زمان ارسال همان روز</span>
                        </div>
                      </div>
                    </div>
                    <div className="flex xs:pb-2 md:pb-4">
                      <div className="pl-2 min-w-[100px]">پنج‌شنبه و جمعه</div>
                      <div className="border-r border-light-gray-300 pr-3">
                        <div className="pb-2">
                          <span>ثبت سفارش بعد از ساعت ۱۲</span>
                          <span className="pr-6">ارسال روز شنبه</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-t border-light-gray-200">
                  <div className="flex xs:mt-3 md:mt-6 ">
                    <div className="pl-2">
                      <Shipping />
                    </div>
                    <div>
                      <p>ارسال از طریق الوپیک و اسنپ باکس برای شهر تهران</p>
                    </div>
                  </div>
                  <div className="flex xs:mt-3 md:mt-6 ">
                    <div className="pl-2">
                      <Clock />
                    </div>
                    <div>
                      <p>۴۸ تا ۷۲ زمان تقریبی دریافت کالا توسط مشتری</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}
